import React from 'react';
import styled from 'styled-components';
import { Modal } from '@roo/roo';
import { useHistory } from 'react-router-dom';

const Root = styled.div`
  .tme-text {
    text-indent: 2em;
  }
`;

function TimeLess(props) {
  const history = useHistory();
  return (
    <Root style={props.style}>
      <Modal
        title="温馨提示"
        visible
        onConfirm={() => {
          history.replace({ pathname: '/' });
        }}
        showCancelButton={false}
      >
        <Root className="box">
          <p className="tme-text">
            感谢您对美团青山科技基金的关注，本期申报已经截止！可关注“美团青山计划”公众号获取最新动态。
          </p>
          <p style={{ marginTop: 12 }} className="tme-text">
            如有任何问题，可通过010-56114793，huanbao@meituan.com联系我们。
          </p>
        </Root>
      </Modal>
    </Root>
  );
}

export default TimeLess;
